export default __webpack_public_path__ + "static/media/virtual-bg18.af2d55ea.png";